export default "__VITE_ASSET__4f47da0e__"